import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

import MapContainerModalMap from '../../containers/MapContainerModalMap';

const ModalMap = ({ headerText, isShownMap, hideMap, ...rest }) => {
  return (
    <Modal show={isShownMap} onHide={hideMap} dialogClassName="mw-100 w-75">
      <Modal.Header closeButton>{headerText}</Modal.Header>
      <Modal.Body>
        <MapContainerModalMap {...rest} />
      </Modal.Body>
    </Modal>
  );
};

ModalMap.propTypes = {
  headerText: PropTypes.string.isRequired,
  isShownMap: PropTypes.bool.isRequired,
  hideMap: PropTypes.func.isRequired
};

export default ModalMap;
